import EndpointError from "../Error/EndpointError";

export default class AxiosErrorResponseToEndpointErrorTransformer {

  to(errorResponse) {
    return new EndpointError(
      errorResponse.message,
      {
        status: errorResponse.response ? errorResponse.response.status : null,
        message: errorResponse.response ? errorResponse.response.data.error : "{NO_MESSAGE}",
        code: errorResponse.response ? errorResponse.response.data.code : null
      }
    );
  }

}
